import React from 'react';
import styled, { css } from 'styled-components';

import { ModalBodyProps } from './types';

const StyledBody = styled.div<{
  $overflowX: 'hidden' | 'scroll';
  $scrollable: boolean;
}>`
  display: flex;
  flex-direction: column;
  width: 100%;
  flex: 1 1 auto;
  min-height: 0;
  background: ${({ theme }) => theme.modal.contentBackgroundColor};

  ${({ $scrollable, $overflowX }) =>
    $scrollable
      ? css`
          overflow-x: ${$overflowX};
          overflow-y: auto;
        `
      : css`
          overflow: visible;
        `}
`;

export const ModalBody: React.FC<ModalBodyProps> = ({
  overflowX = 'hidden',
  scrollable = true,
  className,
  children,
}) => {
  return (
    <StyledBody $overflowX={overflowX} $scrollable={scrollable} className={className}>
      {children}
    </StyledBody>
  );
};
